import type { Locale } from "@eroad/types";

const DEFAULT_LOCALE = "en-NZ";

const SUPPORTED_LOCALES: Locale[] = ["en-NZ", "en-AU", "en-US", "fr-CA"];

const IS_TEST_RUN = process.env.NODE_ENV === "test";

const DEFAULT_TITLE = "Coretex";

const URL_PREFIX = "/tracking2";

export { DEFAULT_LOCALE, DEFAULT_TITLE, IS_TEST_RUN, SUPPORTED_LOCALES, URL_PREFIX };
